import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OtherState } from '@common/components/login/enums/auth-state.enum';
import { RoutePath } from '@common/enums';
import { BrowserService } from '@common/services/browser.service';

@Injectable({ providedIn: 'root' })
export class AppInitService {
  private readonly browserService = inject(BrowserService);
  private readonly router = inject(Router);

  validate(): void {
    if (!this.browserService.isSupportedBrowser()) {
      void this.router.navigate([RoutePath.Account], { queryParams: { state: OtherState.UnsupportedBrowser } });
    }
  }
}
